import { render, staticRenderFns } from "./AnimatePushOnPanel.vue?vue&type=template&id=4fbc7c52&lang=pug&"
import script from "./AnimatePushOnPanel.vue?vue&type=script&lang=js&"
export * from "./AnimatePushOnPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports